<app-home-innovation-section-a></app-home-innovation-section-a>
<app-home-innovation-section-b></app-home-innovation-section-b>
<app-home-innovation-section-c></app-home-innovation-section-c>
<app-home-innovation-section-d></app-home-innovation-section-d>
<app-home-innovation-section-e></app-home-innovation-section-e>